// The Blueprint (mobile): a separate composition designed for a 390px band, not the desktop
// art squeezed down. A hairline skyline across the full width, three blue squares on the left. Sits below the hero copy, never under it. Two planes
// with a light parallax; static under reduced motion.
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';

export function BlueprintMobile({ className = '' }: { className?: string }) {
  const reduce = useReducedMotion();
  const { scrollY } = useScroll();
  const farY = useTransform(scrollY, [0, 600], [0, reduce ? 0 : -16]);
  const nearY = useTransform(scrollY, [0, 600], [0, reduce ? 0 : -44]);
  const plane = 'absolute inset-0 h-full w-full';
  return (
    <div
      className={`relative w-full aspect-[390/220] pointer-events-none ${className}`}
      aria-hidden="true"
    >
      <motion.svg
        className={plane}
        viewBox="0 0 390 220"
        preserveAspectRatio="xMidYMid meet"
        style={{ y: farY }}
      >
        <rect
          x="300"
          y="-20"
          width="90"
          height="160"
          fill="none"
          stroke="var(--ink, #0a0a0b)"
          strokeWidth="1"
          opacity=".22"
        />
        <rect
          x="300"
          y="60"
          width="90"
          height="60"
          fill="none"
          stroke="var(--ink, #0a0a0b)"
          strokeWidth="1"
          opacity=".22"
        />
        <rect
          x="240"
          y="10"
          width="60"
          height="110"
          fill="none"
          stroke="var(--ink, #0a0a0b)"
          strokeWidth="1"
          opacity=".22"
        />
        <rect
          x="190"
          y="40"
          width="50"
          height="80"
          fill="none"
          stroke="var(--ink, #0a0a0b)"
          strokeWidth="1"
          opacity=".22"
        />
        <rect
          x="150"
          y="70"
          width="40"
          height="50"
          fill="none"
          stroke="var(--ink, #0a0a0b)"
          strokeWidth="1"
          opacity=".22"
        />
        <rect
          x="110"
          y="95"
          width="40"
          height="25"
          fill="none"
          stroke="var(--ink, #0a0a0b)"
          strokeWidth="1"
          opacity=".22"
        />
      </motion.svg>
      <motion.svg
        className={plane}
        viewBox="0 0 390 220"
        preserveAspectRatio="xMidYMid meet"
        style={{ y: nearY }}
      >
        <rect x="16" y="172" width="20" height="20" fill="#2563eb" />
        <rect x="44" y="172" width="20" height="20" fill="#2563eb" />
        <rect x="72" y="172" width="20" height="20" fill="#2563eb" />
      </motion.svg>
    </div>
  );
}

export default BlueprintMobile;
